<template>
    <div class="container-fluid">
        <h1>{{$t('menuItemWebJobs')}}</h1>
        <br />
        <span>{{$t('webjobsPageText')}}</span>
        <br />
        <br />
        <div class="col-md-10">
            <!-- Card for SearchCacheClear -->
            <b-card no-body footer-tag="footer">
                <b-card-body>
                    <label>SearchCache legen</label>
                    <p>Gebruik de knop om de Zoek Cache te legen</p>
                    <br />
                    <!-- Start SearchCacheClear Job button -->
                    <base-button :id="`ClearSearchCache`"
                                 :name="`ClearSearchCache`"
                                 class="float-left"
                                 :variant="`primary`"
                                 size="sm"
                                 @click="$_startSearchCacheClear"
                                 :disabled="startSearchCacheClearDisabled"
                                 :text="startSearchCacheClearButtonText">
                    </base-button>
                </b-card-body>
                <!-- Card Footer for SearchCacheClear Job status -->
                <template v-slot:footer>
                    <span>{{$t('state')}}: {{statusSearchCacheClear.description}}</span>
                </template>
            </b-card>
            <br />
            <!-- Card for SearchCache Job -->
            <b-card no-body footer-tag="footer">
                <b-card-body>
                    <label>SearchCache Job</label>
                    <p>{{$t('webjobsScheduledAt')}} 03:00 AM.</p>
                    <br />
                    <!-- Start SearchCache Job button -->
                    <base-button :id="`StartSearchCache`"
                                 :name="`StartSearchCache`"
                                 class="float-left"
                                 variant="primary"
                                 size="sm"
                                 @click="$_startSearchCache"
                                 :disabled="startSearchCacheDisabled"
                                 :text="startSearchCacheButtonText">
                    </base-button>
                </b-card-body>
                <!-- Card Footer for SearchCache Job status -->
                <template v-slot:footer>
                    <span>{{$t('state')}}: {{statusSearchCache.description}}</span>
                </template>
            </b-card>
            <br />
            <!-- Card for FeedbackMaintenance Job-->
            <b-card no-body footer-tag="footer">
                <b-card-body>
                    <label>FeedbackMaintenance Job</label>
                    <p>{{$t('webjobsScheduledAt')}} 11:00 PM.</p>
                    <br />
                    <!-- Start FeedbackMaintenance Job button -->
                    <base-button :id="`StartFeedbackMaintenance`"
                                 :name="`StartFeedbackMaintenance`"
                                 class="float-left"
                                 variant="primary"
                                 size="sm"
                                 @click="$_startFeedbackMaintenance"
                                 :disabled="startFeedbackMaintenanceDisabled"
                                 :text="startFeedbackMaintenanceButtonText">
                    </base-button>
                </b-card-body>
                <!-- Card Footer for FeedbackMaintenance Job status -->
                <template v-slot:footer>
                    <span>{{$t('state')}}: {{statusFeedbackMaintenance.description}}</span>
                </template>
            </b-card>
            <br /><br />
        </div>
    </div>
</template>

<script>
    import { nprogress } from '../../services/utilities';
    import { WEBJOB_STATUS } from '../../constants';

    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import BaseButton from '../../components/BaseComponents/base-button.vue';
    import refcodeMixin from '../../components/Mixins/Refcodes/refcodeMixin.vue';

    export default {
        name: 'WebJobs',

        mixins: [
            modalMixin,
            refcodeMixin
        ],

        components: { 'base-button': BaseButton },

        data() {
            return {
                organizationId: this.$store.getters.userInfo.organizationId,
                report: { messages: [] },
                startSearchCacheClearButtonText: this.$t('webjobsStartSearchCacheClearButtonText'),
                startSearchCacheButtonText: this.$t('webjobsStartSearchCacheButtonText'),
                startVerificationButtonText: this.$t('webjobsStartVerificationButtonText'),
                startFeedbackMaintenanceButtonText: this.$t('webjobsStartFeedbackMaintenanceButtonText'),
                statusSearchCacheClear: { description: '...' },
                statusSearchCache: { description: '...' },
                statusFeedbackMaintenance: { description: '...' },
                webJobStatuses: [],
            };
        },

        computed: {
            startSearchCacheClearDisabled() {
                const statusSearchCacheClearCode = this.statusSearchCacheClear.code;
                return this.$_isInProgress(statusSearchCacheClearCode, 'search-cache-clear');
            },
            startSearchCacheDisabled() {
                const statusSearchCacheCode = this.statusSearchCache.code;
                return this.$_isInProgress(statusSearchCacheCode, 'search-cache');
            },
            startFeedbackMaintenanceDisabled() {
                return this.$_isInProgress(this.statusFeedbackMaintenance.code, 'feedback-maintenance');
            },
        },

        mounted() {
            // Retrieve Language codes
            this.$_initializeWebJobStatuses();
        },

        methods: {
            // Get error message if it exists
            $_getErrorMessage(e) {
                let errorMessage = '';
                if (e.data && e.data.message) {
                    errorMessage = `${this.$t('errorWas')} ${e.data.message}.`;
                }
                return errorMessage;
            },

            // Check if a webjob statusCode still indicates in progress
            $_isInProgress(statusCode, webJobType) {
                switch (webJobType) {
                    case 'search-cache-clear':
                        return statusCode !== WEBJOB_STATUS.SEARCH_CACHE_CLEAR_FINISHED
                            && statusCode !== WEBJOB_STATUS.NO_REQUEST_SENT
                            && statusCode !== WEBJOB_STATUS.SEARCH_CACHE_CLEAR_ERROR;
                    case 'search-cache':
                        return statusCode !== WEBJOB_STATUS.SEARCH_CACHE_FINISHED
                            && statusCode !== WEBJOB_STATUS.NO_REQUEST_SENT
                            && statusCode !== WEBJOB_STATUS.SEARCH_CACHE_ERROR;
                    case 'feedback-maintenance':
                        return statusCode !== WEBJOB_STATUS.FEEDBACK_MAINTENANCE_FINISHED
                            && statusCode !== WEBJOB_STATUS.NO_REQUEST_SENT
                            && statusCode !== WEBJOB_STATUS.FEEDBACK_MAINTENANCE_ERROR;
                }
                return false;
            },

            $_initializeWebJobStatuses() {
                // Retrieve available webjob statuses
                this.getRefCodes('WEBJOB_STATUS').then(result => {
                    for (const webJobStatus of result.data) {
                        this.webJobStatuses.push({
                            code: webJobStatus.code,
                            description: webJobStatus.description,
                        });
                    }
                    // Set initial statusses
                    const noRequestSentStatus = this.webJobStatuses.find(s => s.code === WEBJOB_STATUS.NO_REQUEST_SENT);
                    this.statusSearchCacheClear = noRequestSentStatus;
                    this.statusSearchCache = noRequestSentStatus;
                    this.statusFeedbackMaintenance = noRequestSentStatus;
                });

            },

            async $_startSearchCacheClear() {
                // Set status to Request sent
                this.statusSearchCacheClear = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.REQUEST_SENT_PLEASE_WAIT);
                nprogress.start();

                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'ClearSearchCache'
                    });
                    if (result?.data) {
                        this.statusSearchCacheClear = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_CLEAR_FINISHED);

                    } else {
                        this.statusSearchCacheClear = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_CLEAR_ERROR);
                    }
                    nprogress.done();
                } catch (error) {
                    nprogress.done();
                    // Error!
                    this.showToast({
                        title: this.$t('failStartSearchCacheClear'),
                        message: `${this.$t('errorSearchCacheClear')} ${this.$_getErrorMessage(error)}`,
                        variant: 'danger',
                        autoHideDelay: 5000,
                    });
                    this.statusSearchCacheClear = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_CLEAR_ERROR);
                }

                // Set status to SearchCacheClear in progress
                this.statusSearchCacheClear = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_CLEAR_IN_PROGRESS);
            },

            async $_startSearchCache() {
                // Set status to Request sent
                this.statusSearchCache = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.REQUEST_SENT_PLEASE_WAIT);
                nprogress.start();

                try {
                    // Do request without timeout. PBI is open for changing this to WebSocket + database status column, like the Verification screen
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'SearchCache',
                        config: { timeout: 0 }
                    });
                    if (result?.data) {
                        this.statusSearchCache = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_FINISHED);
                    } else {
                        this.statusSearchCache = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_ERROR);
                    }
                    nprogress.done();
                } catch (error) {
                    nprogress.done();
                    // Error!
                    this.showToast({
                        title: this.$t('failStartSearchCache'),
                        message: `${this.$t('errorSearchCache')} ${this.$_getErrorMessage(error)}`,
                        variant: 'danger',
                        autoHideDelay: 5000,
                    });
                    this.statusSearchCache = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_ERROR);
                }

                // Set status to SearchCache in progress
                this.statusSearchCache = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.SEARCH_CACHE_IN_PROGRESS);
            },

            async $_startFeedbackMaintenance() {
                // Set status to Request sent
                this.statusFeedbackMaintenance = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.REQUEST_SENT_PLEASE_WAIT);
                nprogress.start();

                try {
                    // Do request without timeout
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'StartFeedbackMaintenance',
                        config: { timeout: 0 }
                    });
                    if (result?.data) {
                        this.statusFeedbackMaintenance = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.FEEDBACK_MAINTENANCE_FINISHED);
                    } else {
                        this.statusFeedbackMaintenance = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.FEEDBACK_MAINTENANCE_ERROR);
                    }
                    nprogress.done();
                } catch (error) {
                    nprogress.done();
                    // Error!
                    this.showToast({
                        title: this.$t('failStartFeedback'),
                        message: `${this.$t('errorFeedback')} ${this.$_getErrorMessage(error)}`,
                        variant: 'danger',
                        autoHideDelay: 5000,
                    });
                    this.statusFeedbackMaintenance = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.FEEDBACK_MAINTENANCE_ERROR);
                }

                // Set status to Feedback maintenance in progress
                this.statusFeedbackMaintenance = this.webJobStatuses.find(o => o.code === WEBJOB_STATUS.FEEDBACK_IN_PROGRESS);
            }
        }
    };
</script>
